import { useEffect } from "react"

export function useEffectTimeout(handler: () => void, timeout: number, deps: React.DependencyList = []) {
  useEffect(() => {
    const timer = setTimeout(handler, timeout)
    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
